import { ArrowUp } from "lucide-preact";
import { useEffect, useState } from "preact/hooks";

export type ScrollToTopProps = {
  showAfterScroll?: number;
};

export const ScrollToTop = ({ showAfterScroll = 1000 }: ScrollToTopProps) => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY >= showAfterScroll);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showAfterScroll]);

  if (!showScrollTop) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      class="fixed bottom-18 right-3 p-1 text-gray-50 bg-neutral-500/40 hover:bg-neutral-500/80 border-white dark:border-gray-600 border-2 rounded-full shadow-lg transition-all hover:scale-110 z-1001"
      aria-label="Scroll to top"
    >
      <ArrowUp size={22} />
    </button>
  );
};
